export default __webpack_public_path__ + "static/media/straightImage.7f7330f0.svg";